import { createRouter, createWebHistory } from 'vue-router';
import InstallPage from "@/components/InstallPage.vue";

const routes = [
  { path: '/', component: InstallPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
